import React, { Component } from 'react';
import { InvoiceActionMenu } from '../invoice-components/invoice-action-menu';
import { objectUtils } from '@codametrix/ui-common';
import { Confirm } from '../../confirm/confirm';

import { cmxDateTime, workBench } from '@codametrix/ui-common';
import '../styles/index.scss';
const { getValueAtPath } = workBench.pathUtils;

// Define a type for the props
type InvoiceMetadataProps = {
  editable: boolean;
  onInvoiceMetaEdit?: (invoice: any) => void;
  onInvoiceRemove?: (invoiceGuid: string) => void;
  fields: CMxCommonApp.TextField[];
  idField?: string;
  invoice:
    | CMxCommonApp.CodableInvoice
    | CMxCommonApp.GradeableInvoice
    | Accelerate.CQAInvoice;
};

type InvoiceMetadataState = {
  showRemoveConfirm: boolean;
};

// Define the component
class InvoiceMetadatav2 extends Component<
  InvoiceMetadataProps,
  InvoiceMetadataState
> {
  constructor(props: InvoiceMetadataProps) {
    super(props);
    this.state = {
      showRemoveConfirm: false
    };
  }

  render() {
    const {
      editable,
      invoice,
      onInvoiceMetaEdit,
      onInvoiceRemove,
      fields,
      idField = 'guid'
    } = this.props;

    const handleInvoiceRemove = (ev: React.MouseEvent) => {
      ev.preventDefault();
      const proceedToRemove =
        objectUtils.isEmpty(invoice?.transactions) ||
        (invoice.transactions as any[]).every(transaction => {
          return objectUtils.isEmpty(transaction?.codes);
        });
      if (proceedToRemove) {
        if (invoice[idField]) {
          onInvoiceRemove(invoice[idField]);
        }
      } else {
        this.setState({ showRemoveConfirm: true });
      }
    };

    const handleConfirmRemove = () => {
      if (invoice[idField]) {
        onInvoiceRemove(invoice[idField]);
      }
    };
    const metadataRows = fields
      .map((field, index) => {
        const mainValue = getValueAtPath(invoice, field.path);
        const appendValue = field.appendValuePath
          ? getValueAtPath(invoice, field.appendValuePath)
          : null;
        let value = appendValue ? `${mainValue} (${appendValue})` : mainValue;
        if (value === undefined || value === null) {
          return null; // Skip empty values
        } else if (field.datetimeFormat && value) {
          value = cmxDateTime.format(value, field.datetimeFormat);
        }

        return (
          <p
            key={index}
            className={
              field.classNames.length > 0 ? field.classNames[0].join(' ') : ''
            }>
            {field.displayName && (
              <span className="invoice-meta-label">{field.displayName}:</span>
            )}

            {field.displayName && ' '}

            {value}
          </p>
        );
      })
      .filter(item => item !== null);

    return (
      <div className="invoice-meta-row">
        <div className="invoice-meta-cell-providers">{metadataRows}</div>
        <div className="invoice-meta-cell-actions">
          <Confirm
            onConfirm={handleConfirmRemove}
            onDismiss={e => this.setState({ showRemoveConfirm: false })}
            display={this.state.showRemoveConfirm}
            title="Are you sure you want to remove this invoice?"
            strings={{
              proceed: 'Yes, Remove',
              dismiss: 'No, Cancel'
            }}
          />
          {editable && (
            <InvoiceActionMenu
              onEdit={e => {
                e.preventDefault();
                if (onInvoiceMetaEdit) {
                  onInvoiceMetaEdit(invoice);
                }
              }}
              onDelete={e => {
                e.preventDefault();
                if (onInvoiceRemove) {
                  handleInvoiceRemove(e);
                }
              }}
            />
          )}
        </div>
      </div>
    );
  }
}

export default InvoiceMetadatav2;
